import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectLoadingStatus,
  selectError,
  selectChannels,
  selectMachineTypes,
  selectPlanograms,
  selectChannelKeys,
} from 'src/app/selectors/filterSelectors';
import AppLayout from 'src/components/AppLayout/AppLayout';
import FilterHeader from 'src/components/FilterHeader/FilterHeader';
import { ConfigProvider } from 'src/context/ConfigContext';
import { FilterProvider } from 'src/context/FilterContext';
import { getFilters, updateSelectedFilter } from 'src/slices/filterSlice';
import DashboardGrid from './DashboardGrid';
import { Navigate, Route, Routes } from 'react-router-dom';
import Stores from '../Stores/Stores';
import Users from '../Users/Users';
import TableView from '../TableView/TableView';
import { selectReport, selectUserProfile } from 'src/app/selectors/appDataSelectors';
import FunnelView from '../FunnelView/FunnelView';
import NmsDashGrid from './NmsDashGrid';
import FilterHeaderNMS from 'src/components/FilterHeader/FilterHeaderNMS';
import { selectClientType } from 'src/app/selectors/filterSelectors';

const HomePage = ({
  toggleTheme,
  themeMode,
}: {
  toggleTheme: () => void;
  themeMode: 'light' | 'dark';
}) => {
  const dispatch = useDispatch();
  const userProfile = useSelector(selectUserProfile);
  const [loading, setLoading] = useState<boolean>(false);
  const clientType = useSelector(selectClientType);

  return (
    <ConfigProvider>
      <FilterProvider>
        <AppLayout themeMode={themeMode} toggleTheme={toggleTheme}>
          <div className="pt-1">
            {/* {!loading && <FilterHeader />} */}
            {!loading && (
              clientType == 'NMS' ? <FilterHeaderNMS /> : <FilterHeader />
            )}
            {/* <DashboardGrid /> */}
            <Routes>
              <Route
                path="/"
                element={<Navigate to="transactions" replace />}
              />
              <Route path="transactions" element={<DashboardGrid />} />
              <Route path="interactions" element={<DashboardGrid />} />
              <Route
                path="funnelView"
                element={<FunnelView data={[]} isTile={false} />}
              />
              <Route path="netops" element={<DashboardGrid />} />
              <Route path="inventory" element={<TableView />} />
              <Route path="users" element={<TableView />} />
              <Route path="stores" element={<TableView />} />
              <Route path="reports" element={<TableView />} />
              <Route path="admin" element={<TableView />} />

              <Route path="NMS-Alert-Zendesk" element={<NmsDashGrid />} />
              <Route path="NMS-Worker-Logs" element={<TableView />} />
              <Route path="Alert-Rules" element={<NmsDashGrid />} />

            </Routes>
          </div>
        </AppLayout>
      </FilterProvider>
    </ConfigProvider>
  );
};

export default HomePage;
